import axios from "axios";
import { tokenConfig } from "./websiteActions";
import Swal from "sweetalert2";
import { t } from "i18next";

const loadSetting = () => (dispatch, getState) => {
    return axios.get("/api/user-setting", tokenConfig(getState)).then((res) => {
        return res?.data?.data || {};
    });
};

const updateSetting = (data) => (dispatch, getState) => {
    return axios
        .post("/api/user-setting", data, tokenConfig(getState))
        .then((res) => {
            if (res.data.status === 200) {
                Swal.fire(t("Success"), t(res.data.message), "success");
                return true;
            }

            Swal.fire(t("Error"), t(res.data.message), "error");
        })
        .catch((err) => {
            Swal.fire(t("Error"), t("Something error"), "error");
        });
};

export { loadSetting, updateSetting };
